import { Maybe } from '@csp/csp-common-model';
import { BioAnalyteTypeText, BioAnalyteValueType } from '@csp/csp-common-hbs-model';
import { isDefined } from '@csp/csp-common-util';
import { BookedPatientVisit } from '../../patient-visits/model/BookedPatientVisit';
import { BioSampleSelectPropsMapper } from './BioSampleSelectPropsMapper';

const COMMON_ANALYTE_TYPES = [BioAnalyteValueType.OTHER, BioAnalyteValueType.NA_COLLECTION_TUBE];

const mapToAnalyteTypeTexts = (bookedVisit: Maybe<BookedPatientVisit>): BioAnalyteTypeText[] => {
  if (bookedVisit?.hbsAnalyteTypes.length) {
    return bookedVisit.hbsAnalyteTypes;
    // TODO R10 analyte support
  } else if (bookedVisit?.visitRequest.hbs.analyteTypes.length) {
    // The common analyte types will be added later in call stack
    const analyteTypesExceptCommon = bookedVisit.visitRequest.hbs.analyteTypes.filter(
      analyteType => !COMMON_ANALYTE_TYPES.includes(analyteType),
    );
    return BioSampleSelectPropsMapper.mapAnalyteEnumToText(analyteTypesExceptCommon);
  } else {
    return [];
  }
};

const mapAnalyteValueToText = (value: Maybe<string>): Maybe<string> => {
  if (value && value !== BioAnalyteValueType.UNKNOWN) {
    const analyteText = BioSampleSelectPropsMapper.mapAnalyteEnumToText(
      [value as BioAnalyteValueType],
      undefined,
    ).filter(isDefined)[0];
    if (analyteText) {
      return analyteText;
    } else {
      return value;
    }
  } else {
    return undefined;
  }
};

// TODO R10 analyte support
export const BioSampleAnalyteMapper = {
  mapToAnalyteTypeTexts,
  mapAnalyteValueToText,
};
